import { useState } from "react";
import images from "../assets/gallery"; 
import SEO from "../components/SEO";
// You can export an array from assets/gallery.js, e.g. ["/gallery1.jpg", "/gallery2.jpg", ...]

export default function Gallery() {
  // Just display images in a grid
  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      <SEO
        title="Gallery | Sri Venkateswara Degree & PG College, Nellore"
        description="Browse campus photos and highlights from Sri Venkateswara College, Nellore."
      />
      <h2 className="text-3xl font-semibold text-primary mb-8">Gallery</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {images.map((imgUrl, idx) => (
          <div key={idx} className="overflow-hidden rounded-lg shadow-lg">
            <img
              src={imgUrl}
              alt={`Gallery ${idx + 1}`}
              className="w-full h-48 object-cover transform transition duration-300 hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
